import { render, staticRenderFns } from "./ChannelGroupChannels.vue?vue&type=template&id=186b019c&scoped=true&"
import script from "./ChannelGroupChannels.vue?vue&type=script&lang=ts&"
export * from "./ChannelGroupChannels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186b019c",
  null
  
)

export default component.exports